module.exports = __webpack_public_path__ + "media/images/search-7d459b3e95acc94d63471613cf812023.svg";